export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-primary-500 via-primary-400 to-accent-400 rounded-lg p-8 md:p-12 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="w-16 h-16 md:w-20 md:h-20 flex-shrink-0 bg-background-50/20 rounded-lg flex items-center justify-center">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-2">
              移动端畅享免费耽美漫画
            </h3>
            <p className="text-background-50/90 text-sm leading-relaxed">
              无需下载 APP，手机浏览器直接访问耽美漫画网即可高清阅读。自适应排版专为移动端优化，随时随地免费追 BL 漫画，通勤路上、午休时间都能轻松阅读。
            </p>
          </div>
          <a
            href="#index"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 rounded-md font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap flex-shrink-0"
          >
            立即体验
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}